import { noop } from 'lodash'
import { createContext, useContext } from 'react'

import { TApp } from './types'

export const AppContext = createContext({
  scrollToTop: noop,
})

const useApp = (): TApp => {
  return useContext(AppContext)
}

export default useApp
